<template>
  <div class="h-screen px-0 pt-0 pb-0 mx-0 my-0 box-border">
    <v-row class="h-screen">
      <v-col
        class="lg:flex bg-blue-600 gradient lg:flex-col lg:justify-center px-10 hidden"
        cols="12"
        lg="8"
      >
        <div class="carousel-container h-screen">
          <v-carousel
            v-model="currentSlide"
            cycle
            interval="2000"
            hide-delimiters
            :show-arrows="false"
          >
            <v-carousel-item
              v-for="(slide, i) in slides"
              :key="i"
              :reverse-transition="false"
            >
              <div
                class="max-h-screen"
                :class="{ 'carousel-selected': currentSlide === i }"
              >
                <img :src="slide.image" class="image" />
                <div class="text">
                  <h1 class="text-5xl text-start text-white mb-4">
                    {{ slide.headerText }}
                  </h1>
                  <p class="text-xl text-start text-white">
                    {{ slide.subText }}
                  </p>
                </div>
              </div>
            </v-carousel-item>
          </v-carousel>
        </div>
      </v-col>

      <v-col cols="12" lg="4">
        <v-container>
          <v-row class="flex-grow justify-center items-center">
            <v-col cols="12" sm="10" class="flex justify-end">
              <img
                src="@/assets/img/cualityWork.png"
                class="h-16 w-auto"
                alt="Logo"
              />
            </v-col>
          </v-row>
          <v-row class="flex-grow justify-center items-center mt-16">
            <v-col cols="12" sm="10">
              <h4 class="font-bold text-2xl mb-4">Login</h4>

              <div v-if="formVisible == 'auth'">
                <div v-if="isValidMobile && isOtpValid && !skipOtp">
                  <h2 class="text-center">Set Passcode</h2>
                  <v-text-field
                    outlined
                    dense
                    class="mt-4"
                    v-model="form.setPasscode"
                    label="Set Passcode"
                    @click:append="show1 = !show1"
                    :type="show1 ? 'text' : 'password'"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    hint="Passcode should have 6 digits"
                    v-if="isValidMobile && isOtpValid && !skipOtp"
                  ></v-text-field>
                  <v-text-field
                    outlined
                    dense
                    v-model="form.repeatPasscode"
                    label="Repeat Passcode"
                    @click:append="show2 = !show2"
                    :type="show2 ? 'text' : 'password'"
                    :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                    v-if="isValidMobile && isOtpValid && !skipOtp"
                  ></v-text-field>
                  <v-btn
                    @click="setPasscode()"
                    :color="$vuetify.theme.currentTheme.primary"
                    class="white--text"
                    >Set Passcode</v-btn
                  >
                </div>
                <div v-else>
                  <!-- <v-text-field
                    class="mt-4"
                    outlined
                    dense
                    v-model="form.companyCode"
                    label="Organization Code"
                  ></v-text-field> -->
                  <v-text-field
                    v-model="form.mobile"
                    outlined
                    type="number"
                    dense
                    label="Phone Number"
                  ></v-text-field>
                  <v-text-field
                    outlined
                    dense
                    type="password"
                    v-model="form.passCode"
                    label="Passcode"
                    v-if="isValidMobile && skipOtp"
                  ></v-text-field>
                  <v-text-field
                    outlined
                    type="number"
                    dense
                    v-model="form.otp"
                    label="OTP"
                    v-if="isValidMobile && !skipOtp"
                  ></v-text-field>
                  <v-btn
                    @click="login()"
                    :color="$vuetify.theme.currentTheme.primary"
                    class="white--text"
                    block
                    :loading="isLoad"
                  >
                    {{ loginTxt }}
                  </v-btn>
                </div>
              </div>
              <!-- <v-btn outlined color="grey" class="mt-4" block>Login with SSO</v-btn> -->
            </v-col>
          </v-row>
        </v-container>
        <div class="fixed bottom-4 right-4 z-50">
          <v-btn
            icon
            :color="$vuetify.theme.currentTheme.primary"
            @click="openComplaintCard"
            class="shadow-lg"
          >
            <v-icon>mdi-comment-processing-outline</v-icon>
          </v-btn>
          <QueryComponent
            v-if="isComplaintOpen"
            @handleCloseComplaint="openComplaintCard"
          />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import QueryComponent from "@/components/queryComponent.vue";
import Designer from "@/assets/img/Designer.svg";
import leftImage from "@/assets/img/LeftImage.svg";
import analysisImage from "@/assets/img/Market_analysis.svg";
export default {
  name: "LoginPage",
  layout: "newLayout",
  data() {
    return {
      authData: "",
      form: {
        companyCode: localStorage.getItem("organization_code"),
        mobile: null,
        passCode: null,
        otp: null,
        setPasscode: null,
        repeatPasscode: null,
      },
      isValidMobile: false,
      skipOtp: false,
      show1: false,
      show2: false,
      isOtpValid: false,
      formVisible: "auth",
      tab: 1,
      items: ["Organization Login"],
      // show1: false,
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => v.length >= 8 || "Min 8 characters",
        emailMatch: () => `The email and password you entered don't match`,
      },
      password: "Password",
      currentSlide: 0,
      loginTxt: "Validate",
      isLoad: false,
      isComplaintOpen: false,
    };
  },
  components: {
    QueryComponent,
  },
  computed: {
    slides() {
      return [
        {
          image: Designer,
          headerText: "Best Employee Experience Platform.",
          subText:
            "Don’t limit yourself. Many people limit themselves to what they think they can do. You can go as far as your mind lets you. You achieve what you believe.",
        },
        {
          image: leftImage,
          headerText: "Finally a place where it all comes together",
          subText:
            "Employees like you can even make Mondays a joy. Thanks for your hard work and super attitude.",
        },
        {
          image: analysisImage,
          headerText: "Focus on the work that matters",
          subText:
            "Business opportunities are like buses, there’s always another one coming.",
        },
      ];
    },
  },
  mounted() {
    // const token = this.$storage.getCookie("token");
    // if (token) {
    //   this.$router.push("/workforce/dashboard");
    // } else {
    //   this.$storage.removeUniversal("user");
    // }
  },
  methods: {
    openComplaintCard() {
      this.isComplaintOpen = !this.isComplaintOpen;
    },
    sendOTP() {
      var _this = this;
      _this.form.passCode = null;
      this.$axios
        .post("/auth/otp", { mobile: Number(this.form.mobile) })
        .then(function (res) {
          console.log(res);
          _this.$toast.info("OTP sent!");
        })
        .catch(function (err) {
          console.log(err);
          _this.$toast.error("Failed to send otp");
        });
    },
    validateUser() {
      var _this = this;
      if (!_this.form.mobile) {
        return _this.$toast.error("Please fill company code or mobile number.");
      }
      _this.isLoad = true;
      _this.$axios
        .post("/ext/user", { mobile: _this.form.mobile })
        .then(function (res) {
          const data = res.data;
          if (data.status) {
            _this.isValidMobile = true;
            if (data.skip_otp) {
              _this.skipOtp = true;
            } else {
              _this.skipOtp = false;
              _this.sendOTP();
            }
            if (data.organization_code) {
              localStorage.setItem("organization_code", data.organization_code);
            }
            _this.loginTxt = "Login";
            _this.isLoad = false;
          } else {
            _this.isLoad = false;
            _this.$toast.error("Invalid mobile number");
          }
        })
        .catch((err) => {
          console.log(err);
          _this.isLoad = false;
          _this.$toast.error("Failed to Login! Check Credentials!");
        });
    },
    verifyOTP() {
      var _this = this;
      _this.isLoad = true;
      const payload = {
        mobile: this.form.mobile,
        otp: this.form.otp,
      };
      if (this.tab == 1) {
        payload.organization_code = localStorage.getItem("organization_code");
      }
      this.$axios
        .post("/auth/otp/verify", payload)
        .then(async function (res) {
          if (res.data.access_token) {
            _this.$storage.setUniversal("token", res.data);
            await _this.setUser();
            _this.isOtpValid = true;
          }
          _this.isLoad = false;
        })
        .catch(function (err) {
          console.log(err);
          _this.$toast.error("Invalid OTP");
          _this.isLoad = false;
        });
    },
    async setUser() {
      var authData = this.$storage.getUniversal("token");
      const _this = this;
      await this.$axios.get("/auth/user").then((res) => {
        _this.$storage.setUniversal("user", res.data);
        _this.authData = authData.access_token;
        // const permissionData = this.$storage.getUniversal("user");
        this.$store.dispatch("setWfmPermissions", res.data.wfmPermissions);
      });
    },
    login() {
      var _this = this;
      if (!_this.form.mobile) {
        return _this.$toast.error("Please fill company code or mobile number.");
      }
      _this.isLoad = true;
      if (this.isValidMobile) {
        if (this.form.passCode) {
          const payload = {
            mobile: this.form.mobile,
            passcode: this.form.passCode,
          };
          if (this.tab == 1) {
            payload.organization_code =
              localStorage.getItem("organization_code");
          }
          this.$axios
            .post("/auth/login", payload)
            .then(async function (res) {
              if (res.data.access_token) {
                _this.$storage.setUniversal("token", res.data);
                await _this.setUser();
                const langData = await _this.fetchOrgLang();

                const configData = await _this.getConfig();
                await _this.fetchLoginUserId();
                if (
                  _this.$storage
                    .getUniversal("user")
                    .scope.indexOf("ADMIN_ACCESS") === -1 ||
                  !langData?.orgCode ||
                  !configData?.enabledUseCases?.length
                ) {
                  _this.isLoad = false;
                  _this.$toast.error("You are not an admin");
                  localStorage.clear();
                  _this.$router.push("/login");
                  return;
                }
                if (
                  _this.$storage
                    .getUniversal("user")
                    .role.includes("WFM_ADMIN") ||
                  _this.$storage
                    .getUniversal("user")
                    .role.includes("WFM_ACCESS")
                ) {
                  _this.isLoad = false;
                  _this.$router.replace("/workforce/dashboard");
                  return;
                } else {
                  _this.isLoad = false;
                  _this.$toast.error("You are not an admin");
                  localStorage.clear();
                  return;
                }
              }
            })
            .catch(function (err) {
              console.error(err);
              _this.isLoad = false;
              _this.$toast.error("Invalid credentials");
            });
        } else if (_this.isOtpValid) {
          this.setPasscode();
        } else {
          this.verifyOTP();
        }
      } else {
        this.validateUser();
      }
    },
    async setPasscode() {
      if (
        this.form.setPasscode.length != 6 ||
        this.form.repeatPasscode.length != 6
      ) {
        this.$toast.error("passcode should have 6 digits");
        return;
      }
      if (this.form.setPasscode != this.form.repeatPasscode) {
        this.$toast.error("passcode not matched");
        return;
      }
      try {
        const response = await this.$axios.post("/profile/passcode", {
          passcode: this.form.setPasscode,
        });

        if (response.status === 200) {
          if (
            this.$storage.getUniversal("user").role.includes("WFM_ADMIN") ||
            this.$storage.getUniversal("user").role.includes("WFM_ACCESS")
          ) {
            const langData = await this.fetchOrgLang();
            if (!langData?.orgCode) {
              this.isLoad = false;
              this.$toast.error(
                "Page not found please try after sometime or contact admin"
              );
              localStorage.clear();
              this.$router.push("/login");
              return;
            }
            this.$router.push("/workforce/dashboard");
            this.$toast.success("Passcode set successfully");
            return;
          } else {
            this.isLoad = false;
            this.$toast.error("You are not an admin");
            localStorage.clear();
            return;
          }
        } else {
          console.log("Unexpected response status:", response.status);
        }
      } catch (error) {
        console.error(error);
      }
    },
    async fetchOrgLang() {
      try {
        const response = await this.$axios.get("/workforce/org/lang");
        this.$store.dispatch("setOrgLanguage", response.data);
        return response.data;
      } catch (error) {
        console.error(error);
      }
    },
    async fetchLoginUserId() {
      try {
        const response = await this.$axios.get("/workforce/user");
        const userData = {
          ...this.$storage.getUniversal("user"),
          _id: response.data?.user?._id,
        };

        this.$storage.setUniversal("user", userData);
      } catch (error) {
        console.error(error);
      }
    },
    async getConfig() {
      try {
        const response = await this.$axios.get("/workforce/org/config");

        const data = response.data?.config;
        const obj = {
          directComplete: data.isTaskDirectCompletionAllowedOrg,
          recurAllow: data.isTaskRecurrenceAllowedOrg,
        };
        const jsonString = JSON.stringify(obj);
        localStorage.setItem("task", jsonString);
        return data;
      } catch (error) {
        console.error("Error fetching config:", error);
      }
    },
  },
  watch: {
    tab() {
      this.form.mobile = null;
      this.form.otp = null;
      this.form.passCode = null;
      this.isValidMobile = false;
    },
    "form.mobile"() {
      this.form.otp = null;
      this.form.passCode = null;
      this.isValidMobile = false;
    },
    "form.companyCode"() {
      this.form.companyCode = localStorage.getItem("organization_code");
    },
  },
};
</script>

<style scoped>
.hidden {
  display: none;
}
.gradient {
  background: #5d37bc;
  background: linear-gradient(135deg, #1e3c72, #2a5298);
}
@media (min-width: 1200px) {
  .hidden {
    display: block;
  }
}
.carousel-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.carousel-selected {
  /* transform: scale(1.5); */
}

.image {
  max-width: 100%;
  text-align: start;
  margin: 0;
}
.text {
  padding: 30px;
  text-align: center;
}
</style>
